/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Dangerzone2Inputs */

const zh_organizationsettings_dangerzone2 = /** @type {(inputs: Organizationsettings_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`危险操作`)
};

const en_organizationsettings_dangerzone2 = /** @type {(inputs: Organizationsettings_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger Zone`)
};

const es_organizationsettings_dangerzone2 = /** @type {(inputs: Organizationsettings_Dangerzone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de peligro`)
};

/**
* | output |
* | --- |
* | "Danger Zone" |
*
* @param {Organizationsettings_Dangerzone2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_dangerzone2 = /** @type {((inputs?: Organizationsettings_Dangerzone2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Dangerzone2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_dangerzone2(inputs)
	if (locale === "en") return en_organizationsettings_dangerzone2(inputs)
	return es_organizationsettings_dangerzone2(inputs)
});
export { organizationsettings_dangerzone2 as "organizationSettings_dangerZone" }